import { render, staticRenderFns } from "./TableRequestTickets.vue?vue&type=template&id=02c5f2c1&"
import script from "./TableRequestTickets.vue?vue&type=script&lang=ts&"
export * from "./TableRequestTickets.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports